// Grant-driven dashboard access for the cookie auth path. The legacy JWT path
// has no grants payload and must not call these.

const DASHBOARD_APPLICATION = "dashboard";

export const ALL_STORES = "all";

// The backend already lists `dashboard` on every store it synthesizes for the
// internal groups, so one filter serves internal and granted users alike.
export const dashboardStores = (user) =>
  (user?.stores ?? []).filter((s) =>
    (s.applications ?? []).includes(DASHBOARD_APPLICATION)
  );

// is_atomic_employee covers the two internal groups but not superadmin, which
// the backend reports separately.
export const isInternalUser = (user) =>
  Boolean(user?.is_atomic_employee || user?.is_superadmin);

// Internal users pass on their flags alone: an employee whose tier matches no
// store comes back with an empty store list and must still reach the app.
export const hasDashboardAccess = (user) =>
  Boolean(user && (isInternalUser(user) || dashboardStores(user).length > 0));

// All stores spans every store the user can reach. Internal users get it even
// with an empty list, as the legacy email map gives it to every employee; for
// a single granted store it would only repeat that store.
export const offersAllStores = (user) =>
  isInternalUser(user) || dashboardStores(user).length > 1;

export const landingStore = (user) =>
  offersAllStores(user) ? ALL_STORES : dashboardStores(user)[0]?.code;
